(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  let cartUpdateTimer;

  function submitCartUpdate(input) {
    window.clearTimeout(cartUpdateTimer);

    cartUpdateTimer = window.setTimeout(function () {
      const form = input.closest('.ml-cart__form');
      const updateButton = form && form.querySelector('button[name="update"]');
      if (!form || !updateButton) return;

      form.setAttribute('aria-busy', 'true');

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(updateButton);
      } else {
        updateButton.click();
      }
    }, 250);
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ml-quantity-change]');
    if (!button) return;

    const control = button.closest('[data-ml-quantity]');
    const input = control && control.querySelector('input[type="number"]');
    if (!input) return;

    if (button.dataset.mlQuantityChange === 'plus') {
      input.stepUp();
    } else {
      input.stepDown();
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.ml-cart input[name="updates[]"]');
    if (!input) return;

    const quantity = Number.parseInt(input.value, 10);
    input.value = Number.isNaN(quantity) ? 0 : Math.max(0, quantity);
    submitCartUpdate(input);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moon-lantern-reservation"] && !Shopify.designMode) return;
  try {
    
  const priorityListTarget = document.getElementById('priority-list');

  if (priorityListTarget && 'IntersectionObserver' in window) {
    const priorityListObserver = new IntersectionObserver(
      ([entry]) => document.body.classList.toggle('ml-priority-list-in-view', entry.isIntersecting),
      { rootMargin: '0px 0px -10% 0px' }
    );

    priorityListObserver.observe(priorityListTarget);
  }

  const centerPriorityList = (behavior = 'smooth') => {
    if (!priorityListTarget) return;

    const block = priorityListTarget.getBoundingClientRect().height <= window.innerHeight * 0.82 ? 'center' : 'start';
    priorityListTarget.scrollIntoView({ behavior, block });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href="#priority-list"], a[href$="/#priority-list"]');

    if (!link || !priorityListTarget) return;

    event.preventDefault();
    window.history.replaceState(null, '', '#priority-list');
    centerPriorityList(window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  });

  if (window.location.hash === '#priority-list') {
    window.requestAnimationFrame(() => centerPriorityList('auto'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const opener = event.target.closest('[data-ml-dialog-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.mlDialogOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.removeAttribute('data-closing');
        dialog.showModal();
      }
      return;
    }

    const closer = event.target.closest('[data-ml-dialog-close]');
    if (closer) {
      const dialog = closer.closest('[data-ml-dialog]');
      if (dialog) closeMoonLanternDialog(dialog);
      return;
    }

    if (event.target.matches('[data-ml-dialog]')) {
      closeMoonLanternDialog(event.target);
      return;
    }

    const button = event.target.closest('[data-ml-quantity-change]');
    if (!button) return;

    const control = button.closest('[data-ml-quantity]');
    const input = control && control.querySelector('input[type="number"]');
    if (!input) return;

    if (button.dataset.mlQuantityChange === 'plus') {
      input.stepUp();
    } else {
      input.stepDown();
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener(
    'cancel',
    function (event) {
      if (!event.target.matches('[data-ml-dialog]')) return;

      event.preventDefault();
      closeMoonLanternDialog(event.target);
    },
    true
  );

  function closeMoonLanternDialog(dialog) {
    if (!dialog.open || dialog.dataset.closing === 'true') return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const exitDuration = reduceMotion ? 120 : 160;

    dialog.dataset.closing = 'true';

    window.setTimeout(function () {
      dialog.close();
      dialog.removeAttribute('data-closing');
    }, exitDuration);
  }

  } catch(e) { console.error(e); }
})();
})();
